<!--
  个人资料
  jay 2020-01-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.personalInformation')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll>
        <van-cell-group>
          <van-cell
            :title="$t('personal.modifyAvatar')"
            is-link
            @click="chooseHeadFlag = true"
          >
            <img
              class="head-img"
              :src="
                userInfo.avatar
                  ? httpUrl + userInfo.avatar
                  : require('@/assets/images/public/logo_icon@2x.png')
              "
              alt=""
            />
          </van-cell>
          <van-cell
            :title="$t('personal.modifyNickname')"
            is-link
            :value="userInfo.nickname"
            @click="namePop = true"
          />
          <van-cell
            :title="$t('personal.eepayAccount')"
            :value="userInfo.username"
          />
        </van-cell-group>
      </scroll>
    </div>

    <van-action-sheet
      v-model="chooseHeadFlag"
      :cancel-text="$t('common.cancel')"
    >
      <ul class="selectHead">
        <li @click="selectHead">
          {{ $t("personal.selectMobilePhoto") }}
          <van-uploader :after-read="onRead">
            <img
              v-if="userInfo.avatar"
              ref="headimg"
              :src="httpUrl + userInfo.avatar"
            />
            <img v-else src="@/assets/images/public/logo_icon@2x.png" />
          </van-uploader>
        </li>
      </ul>
    </van-action-sheet>

    <transition name="slide">
      <fileUpload
        v-if="showCropper"
        :img="files"
        :showCropper.sync="showCropper"
        @cropper="_editUserImg"
      ></fileUpload>
    </transition>

    <van-dialog
      v-model="namePop"
      :title="$t('personal.modifyNickname')"
      show-cancel-button
      :beforeClose="changeSubmit"
    >
      <p class="changeTips">{{ $t("verify.nicknameMsg") }}</p>
      <van-field
        class="changeInput"
        :error="nickNameError ? true : false"
        @input="changeNickName"
        v-model="newNickName"
      />
    </van-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as validate from "@/commonJs/validate.js";
import fileUpload from "./fileUpload";
export default {
  name: "userInfo",
  meta: {
    service: false // 客服
  },
  components: {
    fileUpload
  },
  data() {
    return {
      chooseHeadFlag: false,

      showCropper: false,
      files: "",

      namePop: false,
      newNickName: "",
      nickNameError: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    ...mapActions(["GET_USER_INFO"]),
    selectHead() {
      this.chooseHeadFlag = false;
    },
    onRead(file) {
      //添加图片
      let vm = this;
      vm.files = file.content;
      vm.showCropper = true;
    },
    _editUserImg(data) {
      let vm = this;
      let params = {};
      params.avatar = data.split(",")[1];
      // params.avatar = data.split(",")[1];
      vm.$post("/app/user/avatarUpload", params, { loading: true }).then(
        res => {
          console.log("avatarUpload", res);
          vm.showCropper = false;
          vm.$store.dispatch("GET_USER_INFO");
        }
      );
    },
    changeSubmit(action, done) {
      //修改昵称
      let vm = this;
      if (action === "confirm") {
        if (vm.newNickName == "") {
          vm.$toast(vm.$t("verify.nicknameMsg"));
          done(false);
          return;
        }
        if (vm.nickNameError) {
          vm.$toast(vm.nickNameError);
          done(false);
          return;
        }
        let params = {};
        params.nickname = vm.newNickName;
        vm.$post("/app/user/nicknameUpdate", params, {
          loading: true,
          alert: true
        }).then(res => {
          console.log("nicknameUpdate", res);
          if (res.code == 0) {
            vm.GET_USER_INFO({
              obj: {
                nickname: vm.newNickName
              }
            });
          }
          done();
          vm.newNickName = "";
          vm.$toast(res.msg);
        });
      } else {
        //点击取消 弹窗关闭
        vm.newNickName = "";
        done();
      }
    },
    changeNickName() {
      this.nickNameError = validate.validateNickname(this.newNickName);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.van-cell-avatar {
  .van-cell__title,
  .van-cell__value,
  .van-cell__right-icon {
    height: 40px;
    line-height: 40px;
  }
  .van-cell__value img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

/deep/.van-cell {
  display: flex;
  align-items: center;
  .head-img {
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }
}

.selectHead li {
  position: relative;
  text-align: center;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  &:first-child::after {
    content: normal;
  }
  &::after {
    content: " ";
    position: absolute;
    pointer-events: none;
    box-sizing: border-box;
    top: -50%;
    left: -50%;
    right: -50%;
    bottom: -50%;
    transform: scale(0.5);
    border: 0 solid #ebedf0;
    border-top-width: 1.1px;
  }
  /deep/.van-uploader {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    .van-uploader__input-wrapper,
    img {
      width: 100%;
      height: 60px;
    }
  }
}

.changeTips {
  margin: 0 10px;
  text-align: center;
  font-size: 12px;
  color: #4a4a4a;
}

.changeInput {
  width: 214px;
  height: 30px;
  background: #f0f2f5;
  border-radius: 3px;
  padding: 0 16px;
  margin: 16px auto;
  .van-cell__value,
  .van-field__body,
  .van-field__control {
    height: 100%;
  }
}
</style>
